import React from "react";
import styles from "./EmptyState.module.css";
import null_img from "assets/images/empty_img.png";
import { Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import { Container } from "@mui/system";

function EmptyState({ handleClickButton, text, btnText }) {
  return (
    <div className={styles.empty_state}>
      <Container maxWidth="sm">
        <div className={styles.empty_state_content}>
          <img src={null_img} alt="" />
          <div className={styles.text}>
            <Typography>{text}</Typography>
          </div>

          {btnText && (
            <div className={styles.btn}>
              <AppButton
                handleAction={() => {
                  handleClickButton();
                }}
                fullwidth
                textColor="#FFFFFF"
                btnBg="#0089FF"
                btnText={btnText}
              />
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}

export default EmptyState;
